import { render, staticRenderFns } from "./LogOff.vue?vue&type=template&id=0f187de4&scoped=true"
import script from "./LogOff.vue?vue&type=script&lang=ts"
export * from "./LogOff.vue?vue&type=script&lang=ts"
import style0 from "./LogOff.vue?vue&type=style&index=0&id=0f187de4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f187de4",
  null
  
)

export default component.exports